// extracted by mini-css-extract-plugin
module.exports = {"pushesSwitch":"_31IcE0ijzfzWXoUAIPeVm3","switchButton":"_2BrXWjpDEHxpGDvXub7fFG","active":"HWhe-H5xuwDUsyJDeXrV0"};